import { SalesOrder } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1260. 受注案件詳細
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
  enabled?: boolean;
};
const salesOrder = (props: Props): Promise<SalesOrder> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}`);
};

export const useSalesOrder = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => salesOrder(props),
    enabled: props.enabled,
  });
};

export const useSalesOrderInvalidate = (props: Props) => {
  const invalidate = () => salesOrderInvalidate(props);
  return { invalidate };
};

export const salesOrderInvalidate = (props: Props) => {
  queryClient.invalidateQueries({ queryKey: queryKey(props) });
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'sales_orders', props.id];
};
